import React, { useEffect, useState } from 'react';
import {Box, useMediaQuery} from '@mui/material';
import { green, red, red2, yellow } from 'app/components/ThemeProvider/colors';
import { AccountValue } from 'app/constants/types';
import { string } from 'yup';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import logger from 'app/utils/logger';
import { useGetAccount } from 'app/utils/services/accountService';
import { useChangeCardStatus, useChangeSmsNotif, useGetCard } from 'app/utils/services/cardService';
import {getTheme} from "app/components/ThemeProvider/theme";
import {useGetHeaderAndMenu} from "app/utils/services/homePageService";

const useInstantPaymentsSignUp = () => {
    const [btnId, setBtnId] = useState(1);
    const [statusBtnId, setStatusBtnId] = useState(1);

    const navigate = useNavigate();

    const location = useLocation();
    const lang = location.pathname.substring(0, 3);

    const [searchParams] = useSearchParams();
    const pageType = searchParams.get('type');

    const [instantRegist, setInstantRegister] = useState(false);
    const [phoneVerifyModal,setPhoneVerifyModal] = useState(false);
    const theme = getTheme('light');
    const largeScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const tabletScreen = useMediaQuery(theme.breakpoints.down(768));
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const statusFilterBtns = [
        {
            id: 1,
            title: 'Hamısı',
        },
        {
            id: 2,
            title: 'Aktiv',
            icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>,
        },
        {
            id: 3,
            title: 'Bloklaşdırılmış',
            icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: yellow }}></Box>,
        },
    ];
    const paymentStatus = [
        {
            value: 'active',
            label: 'Aktiv',
            icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>,
        },
        {
            value: 'blocked',
            label: 'Bloklaşdırılmış',
            icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: yellow }}></Box>,
        },
        {
            value: 'closed',
            label: 'Bağlı',
            icon: <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: red2 }}></Box>,
        },
    ];


    const [accountData, setAccountData] = useState([]);

    const filterBtns = [
        { id: 1, title: 'Hesablar', route: 'accounts' },
        { id: 2, title: 'Kartlar', route: 'cards' },
        { id: 3, title: 'Ani ödənişlər sistemi', route: 'instant-payments' },
    ];

    const handleChangePageType = (id: number) => {
        setBtnId(id);
        navigate(`${lang}/accounts-card?type=${filterBtns[id - 1].route}`);
    };


    const accountValue = {
        value: '',
        label: 'AZN Hesabim (AZ88NICB00600982750001A40060)',
        balance: '10626.36',
        blocked: '20.00',
        name: 'Euro hesabım',
        govAmount: 'govAmount',
        currency: 'AZN',
        status: 'closed',
        iban: 'AZ88NICB00600982750001A40060',
    };

    const path = location.pathname.substring(3);
    const { isLoadingHeaderAndMenu, dataHeaderAndMenu, refetchGetHeaderAndMenu } = useGetHeaderAndMenu(lang, path);

    const handleSubmit = () => {
        navigate(`${lang}/accounts-card?type=instant-payments`);
    }

    return {
        filterBtns,
        btnId,
        setBtnId,
        accountValue,
        statusFilterBtns,
        statusBtnId,
        setStatusBtnId,
        handleChangePageType,
        pageType,
        accountData,
        setAccountData,
        setInstantRegister,
        instantRegist,
        largeScreen,
        tabletScreen,
        smallScreen,
        isLoadingHeaderAndMenu,
        dataHeaderAndMenu,
        phoneVerifyModal,
        setPhoneVerifyModal,
        handleSubmit
    };
};

export default useInstantPaymentsSignUp;
